import { EventToFitnessTypeDto, InterestDto } from '../models/dto';

export function showNativeAsset(interest: InterestDto, nativeAssetExists: boolean) {
	return (interest.iconId && !interest.hasPriorityOverNativeAsset && nativeAssetExists) || !interest.iconId;
}

export function getMainEventFitnessType(fitnessTypes?: EventToFitnessTypeDto[]): EventToFitnessTypeDto | undefined {
	const mainFitnessType = fitnessTypes?.[0];

	return mainFitnessType;
}
